module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper willmustlist pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "treatment__container"
  }, [_c('div', {
    staticClass: "row bg04"
  }, [_vm._m(0), _c('div', {
    staticClass: "treatment__tabs"
  }, [_c('ul', {
    staticClass: "treatment__tabs__wrap"
  }, [_vm._m(1), _c('li', {
    staticClass: "treatment__tabs__item -leave",
    on: {
      "click": function($event) {
        _vm.goTreatmentLeaveList()
      }
    }
  }, [_c('span', [_vm._v("休暇関連")])]), _c('li', {
    staticClass: "treatment__tabs__item -rule",
    on: {
      "click": function($event) {
        _vm.goTreatmentRuleList()
      }
    }
  }, [_c('span', [_vm._v("制度関連")])])])])]), _c('div', {
    staticClass: "treatment__tab-body"
  }, [_c('div', {
    staticClass: "treatment__tab-contents"
  }, [_vm._m(2), _vm._m(3), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("手当関係")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('post_allowance')
      }
    }
  }, [_vm._v("役職手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('extra_allowance')
      }
    }
  }, [_vm._v("割増手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('adjustment_allowance')
      }
    }
  }, [_vm._v("調整手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('housing_allowance')
      }
    }
  }, [_vm._v("住宅手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('commuting_allowance')
      }
    }
  }, [_vm._v("通勤手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('support_allowance')
      }
    }
  }, [_vm._v("応援手当")]), _vm._m(4)]), _vm._m(5), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("転勤")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('assignment_allowance')
      }
    }
  }, [_vm._v("赴任手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('moving_allowance')
      }
    }
  }, [_vm._v("引越手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('homecoming_allowance')
      }
    }
  }, [_vm._v("帰省旅費手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('rental_housing_assistance')
      }
    }
  }, [_vm._v("賃貸住宅補助")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('other_expence')
      }
    }
  }, [_vm._v("その他費用")]), _vm._m(6)]), _vm._m(7), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("慶弔・医療")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('congratulatory_condolence_money')
      }
    }
  }, [_vm._v("慶弔見舞金")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('sick_childcare_allowance')
      }
    }
  }, [_vm._v("病児保育補助手当")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('flu_vaccination')
      }
    }
  }, [_vm._v("インフル予防接種")]), _vm._m(8)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__heading"
  }, [_c('h2', {
    staticClass: "treatment__heading__title"
  }, [_c('span', {
    staticClass: "treatment__heading__img"
  }, [_c('div', {
    staticClass: "heading_01-treatment"
  }, [_vm._v("待遇・制度の一覧だニャン！")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "treatment__tabs__item -salary -active"
  }, [_c('span', [_vm._v("給与関連")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-notice"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_02.png"),
      "alt": "",
      "width": "48px",
      "height": "42px"
    }
  }), _c('h2', {
    staticClass: "treatment__tab-notice-baloon"
  }, [_vm._v("給与関係は忘れずに申請を行うんだニャン！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_climbing_man.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-comment"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_05.png"),
      "alt": "",
      "width": "46px",
      "height": "46px"
    }
  }), _c('span', [_vm._v("仕事以外のサポートが充実しているニャン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_track.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-comment"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_02.png"),
      "alt": "",
      "width": "46px",
      "height": "46px"
    }
  }), _c('span', [_vm._v("安心して働けるニャン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_heart.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-comment"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_43.png"),
      "alt": "",
      "width": "46px",
      "height": "46px"
    }
  }), _c('span', [_vm._v("充実した支援だニャン")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-560909da!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/treatment-salary-list.pug
// module id = 1395
// module chunks = 1